export default "/images/e859d418baac20a6bf17b83f99ae9067.avif";